import React from 'react'
import './css/App.css';
import underMaintenance from './assets/img/underMaintenance.png'
import revfinLogo from './images/logo.png'

export const UnderMaintenance = () => {
    return (
        <div className="um-container">

            <img src={revfinLogo}  className='revfin-logo' alt=""/>

            <img src={underMaintenance} className='underMaintenance' alt="" />

            <div className=" maintain">
                <h1 className="backSoon-header">We&rsquo;ll be back soon!</h1>

                <div>
                    <p className="maintain">Sorry for the inconvenience. We&rsquo;re performing some maintenance at the moment. We&rsquo;ll be back up shortly!</p>
                    <li className="maintain revfinTeam" >Team Revfin</li>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/underMaintenance.jsx